<template>
  <div
    id="print-component"
    style="width: 2840; height: 3548px;"
  >
    <header-layout
      style="top: 0; position: fixed; height:700px;"
      :hospital-profile="hospitalProfile"
      :corporation="corporation"
      :pet="pet"
    />
    <table>
      <thead>
        <tr>
          <td>
            <div class="header-space">
&nbsp;
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="content">
              <result-layout />
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="footer-space">
&nbsp;
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
   
    <footer-layout
      style="bottom: 0; position: fixed; height:450px;"
      :latest-report="latest_report"
      :latest-approve="latest_approve"
    />
  </div>
</template>

<script>
import HeaderLayout from "./HeaderLayout"
import ResultLayout from "./ResultLayout"
import FooterLayout from "./FooterLayout"

export default {
  name: "PrintComponent",
  components: {
    HeaderLayout,
    ResultLayout,
    FooterLayout
  },
  data() {
    return {
      hospitalProfile: {
        name: 'สถานที่ 119สัตวแพทย์',
      },
      corporation: {
        name: 'VET & VETRO RATCHAPRUK LAB CENTER เวท แอนด์ วิทโทร ราชพฤษ์ แล็บ เซ็นเตอร์',
        address: 'หมู่บ้านพฤกษาทาวน์ ราชพฤกษ์ หมู่ 10 ถ.ราชพฤกษ์ ต.บางกร่าง อ.เมือง จ.นนทบุรี 11000',
        phone: '0984027590, 0988488972, 0988488973'
      },
      pet: {
        ownerName: 'คุณ แหม่ม',
        patientName: 'นิล',
        hospitalNumber: '1',
        sex: 1, // NOTE :: 1=male, 2=female, 3=unknown
        age: 10,
        ln: 102333391,
        spp: 'Ferline',
        breed: 'Mixed'
      },
      latest_report: {
        user: {
          name: 'ชนัฐฐา ประกลม'
        },
        created_at: '19/12/2561 Time 13.53'
      },
      latest_approve: {
        user: {
          name: 'อัจฉรา สวียม'
        },
        created_at: '19/12/2561 Time 13.53'
      }
    }
  }
}
</script>

<style lang="scss">

</style>

